import { inject, Injectable } from '@angular/core';

import { IFunctionMemberListDto } from 'src/assets/common/models/function-member-list-dto.g';
import { _ListService } from 'src/app/infrastructure/services/list-services/_list.service';
import { FunctionMemberListData, IFunctionMemberListData } from '../models/function-member-list-data';
import { tabName } from 'src/app/infrastructure/services/page-services/models/tab-name';
import { LoadingService } from 'src/app/infrastructure/services/loading-services/_loading.service';
import { TabListService } from '../../shared/central-page/services/tab-list.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Injectable()
export class FunctionMemberListService
    extends _ListService<IFunctionMemberListDto, IFunctionMemberListData>
{
    protected override readonly _loadingService = injectRequired(LoadingService);
    protected override readonly _tabListService = inject(TabListService, { optional: true });

    // Generieke verdeling; dat beëindigde functies gedimd in de hoofdlijst staan, regelt de tablist met
    // [inactiveMode]="dimmed" (zie FunctionMemberTablistComponent). Wie geen historie mag zien (claim
    // FunctionMembers/SuperiorData/Read), krijgt ze van de backend al niet mee (FunctionMemberController.__History_filter).
    override listActive$ = this._listActive$;
    override hasDeletedList$$ = this._hasDeletedList$$;
    override hasInactiveList$$ = this._hasInactiveList$$;
    override listActive$$ = this._listActive$$;
    override listAll$$ = this._listAll$$;
    override listDeleted$$ = this._listDeleted$$;
    override listDeletedAll$$ = this._listDeletedAll$$;
    override listInactive$$ = this._listInactive$$;

    override listName = tabName.functionMembers;

    override list_refresh$ = this._list_refresh$;

    override list_load$ = this._list_load$;

    override listData_load(listDto: IFunctionMemberListDto): IFunctionMemberListData | null {
        return FunctionMemberListData.create(listDto);
    }
}
